import { FC, ReactElement } from 'react';

const BottomFormLayout: FC<{ children: ReactElement }> = ({ children }) => {
  return <div className="px-20 py-4 bg-specialGray-004 flex justify-between rounded-b-xl">{children}</div>;
};

export default BottomFormLayout;
